import type { AudienceRuleAct, AudienceRuleDateReference, AudienceRuleDateType } from './audiences.enum'

export class AudienceRule {
    audienceId?: string
    audienceRuleId: string
    act: AudienceRuleAct
    event: string
    value: string
    dateType: AudienceRuleDateType
    dateFrom: number
    dateTo: number
    dateReference: AudienceRuleDateReference
    createdAt: Date
    updatedAt: Date
    total: number
    lastEvent: boolean
}
